import { Component, OnInit,ViewChild,ElementRef  } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl, NgForm } from '@angular/forms';
import { ApiService } from '../api.service';
import { RouterModule, Routes, Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExcelServiceService } from '../excel-service.service';
import { DateService } from '../date.service';
const FILE_NAME = "Customer Registration Export";
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';
import { Location } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $: any;

@Component({
  selector: 'app-jobcardupload',
  templateUrl: './jobcardupload.component.html',
  styleUrls: ['./jobcardupload.component.css']
})
export class JobcarduploadComponent implements OnInit {
  @ViewChild('excelFileInput')
excelFileInput!: ElementRef<HTMLInputElement>;

  userDetails = { 'usertype': '', 'sub': '','userid': '' };
  query = {};
  success = { 'description': [] };
  error = { 'description': [] };

  constructor(public excelService: ExcelServiceService, public apiService: ApiService, private route: ActivatedRoute, private location: Location, public router: Router, private spinner: NgxSpinnerService, public dateService: DateService) { }

  selectedStatus = '';
    selectedFiles: any = [];
    uploadErr = false;
    createInvoiceForm: FormGroup;
    exceltemplate:String="";
  
    successCount:any=[];
    failedCount:any=[];
    totalCount:any;
    totalRecords: any;
    totalSuccessCount:any;
    totalFaildeCount:any;

  ngOnInit() {
    this.createInvoiceForm = new FormGroup({      
      AttachmentExcel: new FormControl()
      
    })
  }

  confirmationModalFileUploadSubmit(createInvoiceForm: any) {
    let payload = new FormData();
    
      payload.append("Files", this.selectedFiles[0], this.selectedFiles[0].name);    
      this.spinner.show();
      this.apiService.uploadJobCard(payload).subscribe(res => {
      if (res.succeeded) {
        console.log(res.content.payLoad)
        console.log(res.content.payLoad.totalResultCount);
        this.successCount = res.content.payLoad.successCount;
        this.failedCount = res.content.payLoad.failedCount;
        this.totalCount = res.content.payLoad.totalResultCount;
        this.totalRecords=res.content.payLoad.totalResultCount.totalRecords;
        this.totalSuccessCount=res.content.payLoad.totalResultCount.successCount;
        this.totalFaildeCount=res.content.payLoad.totalResultCount.failedCount;

        console.log('Total Records:- ' + this.totalRecords + ' Total SuccessCount :- ' + this.totalSuccessCount +  ' Total Failed Count:- ' + this.totalFaildeCount);
        this.spinner.hide();     
        if(this.successCount.length>0 && this.failedCount.length <=0){
          
          this.success.description = ["Job Card Bulk Data Completed Successfully!"];
        }
        else if(this.successCount.length<=0 && this.failedCount.length >0){
          
          this.success.description = ["Job Card Bulk Data Completed Faild!"];
        } 
         else if(this.successCount.length>0 && this.failedCount.length >0){
         
          this.success.description = ["Job Care Bulk Data Completed with " + this.successCount + " Success and " + this.failedCount + " Faild !"];
        } 
        
        //this.closeBulkUpload();
        setTimeout(function () {
          $(".myAlert-top").hide();
        }, 5000);

      }           
    }, error => {
      if (error.error.errors.length > 0) {
        this.error.description.push(error.error.errors[0]['description']);        
      }
      this.spinner.hide();
    })
  }

   handleExcelInput($files) {

    let filecount = this.selectedFiles.length + $files.target.files.length;

    if (filecount > 1) {
      this.uploadErr = true;
      this.createInvoiceForm.get('AttachmentExcel').reset('');
      return;
    }
    
      let file = $files.target.files[0];      
      //console.log(file);
      if (file.type && file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        var self = this;
        reader.onload = function (e) {
          
          //Validate the File Size.          
            if ( Math.round(file.size / 1024 / 1024) <= 5) {
              self.uploadErr = false;

              if (file.name.length > 35) {
                file.fileName = file.name.substring(0, 32).concat('...');
              } else {
                file.fileName = file.name;
              }
              self.selectedFiles.push(file);
            } else {
              self.uploadErr = true;
              self.createInvoiceForm.get('AttachmentExcel').reset('');
              self.selectedFiles = [];
            }          
        };
      }
      else {
        this.uploadErr = true;
        this.createInvoiceForm.get('AttachmentExcel').reset('');
        this.selectedFiles = [];
      }    
  }

}
